import React from 'react'
import Link from 'gatsby-link'

const BioTray = props => {
 const { activeProfile, teamTray } = props
 return (
    <div id="member-tray" className={ teamTray ? 'open' : null }>
        <div className="close-area" onClick={ () => props.unsetActiveFellow()  } />
        <div className="container">
            <div className="container">
            { activeProfile &&
                <div>
                    {
                        activeProfile.image &&
                        <img src={ activeProfile.image.resize.src } alt={ activeProfile.name } />
                    }
                    <h1 className="h3">{ activeProfile.name }</h1>
                    { (activeProfile.country || activeProfile.programYear) && <p className="italic">{ activeProfile.country ? activeProfile.country.title + ' - ' : '' } { activeProfile.programYear ? activeProfile.programYear.title : '' }</p> }
                    { activeProfile.title && <p className="italic">{ activeProfile.title }</p> }
                    <hr/>
                    {
                        activeProfile.bio &&
                        <p style={{ marginBottom:'15px' }} dangerouslySetInnerHTML={{ __html: activeProfile.bio.bio }} />
                    }
                    { activeProfile.fellowsCard &&
                        <Link className="button button-small" style={{ marginBottom:'10px' }} to={ activeProfile.fellowsCard.fellowsLink.link }>Read { activeProfile.name.substr(0,activeProfile.name.indexOf(' '))}'s Story</Link>
                    }
                    { !props.noLink &&
                        <Link className="hoverlink" to={ `/author/${activeProfile.name.replace(/\s/g,'-').toLowerCase() }/`}>Read { activeProfile.name }'s Blog</Link>
                    }
                    <div className="close" onClick={ () => props.unsetActiveFellow() }>
                        <img src="/images/icon-close.svg" alt=""/>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
)}


export default BioTray



// WEBPACK FOOTER //
// ./src/components/BioTray/index.js